export var defaultLanguages = [
    { index: 0, name: "English", nativeName: "English", googleAbbr: "en" },
    { index: 1, name: "Spanish", nativeName: "Espa\xF1ol", googleAbbr: "es" },
    { index: 2, name: "French", nativeName: "Fran\xE7aise", googleAbbr: "fr" },
    { index: 3, name: "Italian", nativeName: "Italiano", googleAbbr: "it" },
    { index: 4, name: "German", nativeName: "Deutsch", googleAbbr: "de" },
    { index: 5, name: "Portuguese", nativeName: "Portugu\xEAs", googleAbbr: "pt" },
    { index: 99, name: "More", nativeName: "More", googleAbbr: "" }
];
export var moreLanguages = [
    { index: 4, name: "Less", nativeName: "Less", googleAbbr: "" },
    { index: 6, name: "Arabic", nativeName: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629", googleAbbr: "ar" },
    { index: 7, name: "Armenian", nativeName: "\u0570\u0561\u0575\u0565\u0580\u0567\u0576", googleAbbr: "hy" },
    { index: 8, name: "Chinese", nativeName: "\u6C49\u8BED\u002F\u6F22\u8A9E", googleAbbr: "zh-cn" },
    { index: 9, name: "Haitian Creole", nativeName: "Krey\xF3l ayisyen", googleAbbr: "ht" },
    {
        index: 10,
        name: "Hindi",
        nativeName: "\u092E\u093E\u0928\u0915\u0020\u0939\u093F\u0928\u094D\u0926\u0940",
        googleAbbr: "hi"
    },
    { index: 11, name: "Japanese", nativeName: "\u65E5\u672C\u8A9E", googleAbbr: "ja" },
    { index: 12, name: "Korean", nativeName: "\uD55C\uAD6D\uC5B4", googleAbbr: "ko" },
    { index: 13, name: "Filipino", nativeName: "Filipino", googleAbbr: "tl" },
    { index: 14, name: "Polish", nativeName: "Polski", googleAbbr: "pl" },
    { index: 15, name: "Russian", nativeName: "\u0050\u0079\u0063\u0063\u0138\u0438\u0439", googleAbbr: "ru" },
    { index: 16, name: "Thai", nativeName: "\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22", googleAbbr: "th" },
    {
        index: 17,
        name: "Vietnamese",
        nativeName: "\u0054\u0069\u00EA\u0301\u006E\u0067\u0020\u0056\u0069\u00EA\u0323\u0074",
        googleAbbr: "vi"
    },
    { index: 18, name: "Amharic", nativeName: "\u12A0\u121B\u122D\u129B", googleAbbr: "am" },
    { index: 19, name: "Gujarati", nativeName: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0", googleAbbr: "gu" },
    { index: 20, name: "Bengali", nativeName: "\u09AC\u09BE\u0982\u09B2\u09BE", googleAbbr: "bn" },
    { index: 21, name: "Bosnian", nativeName: "\u0431\u043E\u0441\u0430\u043D\u0441\u043A\u0438", googleAbbr: "bs" },
    { index: 22, name: "Croatian", nativeName: "Hrvatski", googleAbbr: "hr" },
    { index: 23, name: "Czech", nativeName: "\u010De\u0161tina", googleAbbr: "cs" },
    { index: 24, name: "Danish", nativeName: "Dansk", googleAbbr: "da" },
    { index: 25, name: "Dutch", nativeName: "Nederlands", googleAbbr: "nl" },
    { index: 26, name: "Estonian", nativeName: "Eesti", googleAbbr: "et" },
    { index: 27, name: "Finnish", nativeName: "Suomen kieli", googleAbbr: "fi" },
    { index: 28, name: "Greek", nativeName: "\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC", googleAbbr: "el" },
    { index: 29, name: "Hebrew", nativeName: "\u05E2\u05D1\u05E8\u05D9\u05EA\u202C", googleAbbr: "iw" },
    { index: 30, name: "Hmong", nativeName: "Lus Hmoob", googleAbbr: "hmn" },
    { index: 31, name: "Hungarian", nativeName: "Magyar", googleAbbr: "hu" },
    { index: 32, name: "Indonesian", nativeName: "Bahasa Indonesia", googleAbbr: "id" },
    { index: 33, name: "Javanese", nativeName: "Wong Jawa", googleAbbr: "jw" },
    {
        index: 34,
        name: "Kazakh",
        nativeName: "\u049A\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456",
        googleAbbr: "kk"
    },
    { index: 35, name: "Kurdish", nativeName: "Kurd\u00EE", googleAbbr: "ku" },
    { index: 36, name: "Lao", nativeName: "\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7", googleAbbr: "lo" },
    { index: 37, name: "Latvian", nativeName: "Latvie\u0161u", googleAbbr: "lv" },
    { index: 38, name: "Lithuanian", nativeName: "Lietuvi\u0173", googleAbbr: "lt" },
    { index: 39, name: "Malayalam", nativeName: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02", googleAbbr: "ml" },
    { index: 40, name: "Maori", nativeName: "M\u0101ori", googleAbbr: "mi" },
    { index: 41, name: "Marathi", nativeName: "\u092E\u0930\u093E\u0920\u0940", googleAbbr: "mr" },
    { index: 42, name: "Nepali", nativeName: "\u0928\u0947\u092A\u093E\u0932\u0940", googleAbbr: "ne" },
    { index: 43, name: "Norwegian", nativeName: "Norsk", googleAbbr: "no" },
    { index: 44, name: "Pashto", nativeName: "\u067E\u069A\u062A\u0648", googleAbbr: "ps" },
    { index: 45, name: "Persian/Farsi", nativeName: "\u0641\u0627\u0631\u0633\u06CC", googleAbbr: "fa" },
    { index: 46, name: "Punjabi", nativeName: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40", googleAbbr: "pa" },
    { index: 47, name: "Romanian", nativeName: "Rom\u00E2n\u0103", googleAbbr: "ro" },
    { index: 48, name: "Samoan", nativeName: "S\u0101moa", googleAbbr: "sm" },
    { index: 49, name: "Serbian", nativeName: "\u0441\u0440\u043F\u0441\u043A\u0438", googleAbbr: "sr" },
    { index: 50, name: "Shona", nativeName: "ChiShona", googleAbbr: "sn" },
    { index: 51, name: "Sinhala", nativeName: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD", googleAbbr: "si" },
    { index: 52, name: "Slovak", nativeName: "Sloven\u010Dina", googleAbbr: "sk" },
    { index: 53, name: "Slovenian", nativeName: "Sloven\u0161\u010Dina", googleAbbr: "sl" },
    { index: 54, name: "Somali", nativeName: "Soomaali", googleAbbr: "so" },
    { index: 55, name: "Swahili", nativeName: "Kiswahili", googleAbbr: "sw" },
    { index: 56, name: "Swedish", nativeName: "Svenska", googleAbbr: "sv" },
    { index: 57, name: "Tamil", nativeName: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD", googleAbbr: "ta" },
    { index: 58, name: "Telugu", nativeName: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41", googleAbbr: "te" },
    { index: 59, name: "Turkish", nativeName: "T\u00FCrk\u00E7e", googleAbbr: "tr" },
    {
        index: 60,
        name: "Ukrainian",
        nativeName: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        googleAbbr: "uk"
    },
    { index: 61, name: "Urdu", nativeName: "\u0627\u064F\u0631\u062F\u064F\u0648\u202C", googleAbbr: "ur" },
    { index: 62, name: "Yoruba", nativeName: "Yor\u00F9b\u00E1", googleAbbr: "yo" }
];
